import React from "react";
import usePlacesAutocomplete from "use-places-autocomplete";


const GoogleAddressInput = ({ value, onChange }) => {
  const {
    ready,
    value: inputVal,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete();

  const handleInput = (e) => {
    setValue(e.target.value);
    onChange(e.target.value);
  };

  const handleSelect = (address) => {
    setValue(address, false);
    clearSuggestions();
    onChange(address);
  };

  return (
    <div className="relative">
      <input
        value={inputVal}
        onChange={handleInput}
        disabled={!ready}
        placeholder="Enter full address"
        className="p-2 w-full border shadow-custom-light rounded-custom focus:outline-none"
      />
      {status === "OK" && (
        <ul className="absolute bg-white z-10 w-full mt-1 border rounded shadow">
          {data.map(({ place_id, description }) => (
            <li
              key={place_id}
              onClick={() => handleSelect(description)}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              {description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

 
export default GoogleAddressInput;
